/* eslint-disable react-hooks/exhaustive-deps */
import Card from "@mui/material/Card";
import {
  Box,
  Button,
  Grid,
  Icon,
  IconButton,
  Modal,
  Typography,
} from "@mui/material";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 PRO React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataPaginateTable from "examples/Tables/DataPaginateTable";
import NotificationItem from "examples/Items/NotificationItem";

import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { URL_API } from "config";
import MDInput from "components/MDInput";
import { useAuthContext } from "context/AuthContext";

function PATable() {
  const [pas, setPas] = useState([]);

  const [rowSelected, setRowSelected] = useState();

  const [tableLimit, setTableLimit] = useState(10);
  const [tablePage, setTablePage] = useState(1);
  const [tableTotal, setTableTotal] = useState(0);

  const [guid, setGuid] = useState();
  const [open, setOpen] = useState(false);

  const navigate = useNavigate();
  const [filter, setFilter] = useState("");

  const { user } = useAuthContext();

  var dataTableData = {
    columns: [
      { Header: "Número", accessor: "number", width: "20%" },
      { Header: "Nome", accessor: "name", width: "35%" },
      { Header: "Regional", accessor: "regional" },
      { Header: "UUID", accessor: "uuid" },
      { Header: "Ações", accessor: "action", width: "7%" },
    ],
    rows: pas,
  };

  let tag = localStorage.getItem("Tag");
  const HEADER = {
    headers: {
      Authorization: `Bearer ${tag}`,
    },
  };

  async function getPas(page = 1, limit = 10, filter = "") {
    const filterValue =
      filter !== undefined && filter !== "" ? `&filter=${filter.trim()}` : "";
    await axios
      .get(`${URL_API}/pas?page=${page}&limit=${limit}${filterValue}`, HEADER)
      .then(function (response) {
        setPas(response.data?.data);
        setTableTotal(response?.data.meta?.total);
      })
      .catch(function (error) {
        if (error?.response?.status === 401) {
          localStorage.removeItem("Tag");
          navigate("/auth/login");
        } else {
          toast.error(error?.response?.data?.message);
        }
      });
  }

  async function handleDelete(guid) {
    await axios
      .delete(URL_API + `/pa/${guid}`, HEADER)
      .then(function () {
        setOpen(!open);
        getPas(1, tableLimit, filter);
        setTablePage(1);
      })
      .catch(function (error) {
        if (error?.response?.status === 401) {
          localStorage.removeItem("Tag");
          navigate("/auth/login");
        } else {
          toast.error(error?.response?.data?.message);
        }
      });
  }

  useEffect(() => {
    if (user?.profile !== 99) navigate("/admin/dashboard");
    getPas(tablePage, tableLimit, filter);
    return () => {
      setPas([])
    }
  }, [tablePage, tableLimit]);

  return (
    <>
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox pt={6} pb={3}>
          <Card>
            <MDBox pt={2}>
              <MDBox
                p={3}
                lineHeight={1}
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <MDTypography variant="h5" fontWeight="medium">
                  Filtro para PA's
                </MDTypography>
              </MDBox>
              <MDBox
                p={1}
                lineHeight={1}
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <Grid container spacing={2}>
                  <Grid item>
                    <MDInput
                      label="Buscar por PA's..."
                      onChange={async (event) => {
                        const { value } = event.target;
                        if (value && value !== "") setFilter(value);
                        else {
                          getPas(1, tableLimit);
                          setTablePage(1);
                          setFilter("");
                        }
                      }}
                      size="large"
                    />
                  </Grid>
                  <Grid item>
                    <IconButton
                      onClick={async () => {
                        setTablePage(1);
                        await getPas(1, tableLimit, filter);
                      }}
                      sx={{
                        color: "#fff",
                        background: "#3f50b5",
                        borderRadius: "8px",
                        "&:hover": {
                          backgroundColor: "blue",
                        },
                      }}
                    >
                      <Icon>search</Icon>
                    </IconButton>
                  </Grid>
                </Grid>
              </MDBox>
            </MDBox>
          </Card>
          <MDBox pt={2}>
            <Card>
              <MDBox
                p={3}
                lineHeight={1}
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <MDTypography variant="h5" fontWeight="medium">
                  PA's
                </MDTypography>
                <MDButton
                  color="light"
                  onClick={() => {
                    navigate("/admin/pas/criar");
                  }}
                >
                  Novo
                </MDButton>
              </MDBox>
              <DataPaginateTable
                entriesPerPage={{ defaultValue: tableLimit }}
                table={dataTableData}
                onRowSelected={setRowSelected}
                setTableLimit={setTableLimit}
                tableLimit={tableLimit}
                setTablePage={setTablePage}
                tablePage={tablePage}
                tableTotal={tableTotal}
              >
                <NotificationItem
                  onClick={() => {
                    navigate(
                      "/admin/pas/atualizar/" + rowSelected.original.uuid
                    );
                  }}
                  icon={<Icon>create</Icon>}
                  title="Editar"
                />
                <NotificationItem
                  onClick={() => {
                    setGuid(rowSelected.original.uuid);
                    setOpen(!open);
                  }}
                  icon={<Icon>delete</Icon>}
                  title="Deletar"
                />
              </DataPaginateTable>
            </Card>
          </MDBox>
        </MDBox>
      </DashboardLayout>
      <ToastContainer />

      <Modal
        open={open}
        onClose={() => setOpen(!open)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        style={{
          overflow: "scroll",
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            margin: "15%",
            width: "40%",
            padding: "25px",
            borderRadius: "40px",
            height: "fitContent",
            background: "#fff",
            display: "flex",
            justifyContent: "space-around",
            flexDirection: "column",
            textAlign: "center",
          }}
        >
          <Typography textAlign="center" sx={{ marginBottom: 2 }}>
            Deseja mesmo deletar o PA?
          </Typography>

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-around",
              flexDirection: "column",
              textAlign: "center",
            }}
          >
            <Button
              variant="contained"
              sx={{ color: "#fff", marginX: 4, marginY: 2 }}
              onClick={() => handleDelete(guid)}
            >
              Sim
            </Button>
            <Button
              variant="contained"
              sx={{
                marginX: 4,
                marginY: 2,
                bgcolor: "red",
                color: "#fff",
                ":hover": { bgcolor: "red" },
              }}
              onClick={() => setOpen(!open)}
            >
              Não
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
}

export default PATable;
